import React, { useState, useContext, createContext } from "react"

import { getPastDate, getDifferenceBetweenDates } from "util/formatters"

const siteSettingsContext = createContext()

// Context Provider component that wraps your app and makes settings object
// available to any child component that calls the useSiteSettings() hook.
export function SiteSettingsProvider({ children, ...props }) {
  const settings = useSettingsProvider()
  return (
    <siteSettingsContext.Provider value={settings} {...props}>
      {children}
    </siteSettingsContext.Provider>
  )
}

// Hook that enables any component to subscribe to site settings state
export const useSiteSettings = () => {
  return useContext(siteSettingsContext)
}

// Provider hook that creates settings object and handles state
function useSettingsProvider() {
  // default to 30 days, excluding today because it's not yet available
  const defaultStartDate = getPastDate(30, "day")
  const defaultEndDate = getPastDate(1, "day")
  const [selectedStartDate, setSelectedStartDate] = useState(defaultStartDate)
  const [selectedEndDate, setSelectedEndDate] = useState(defaultEndDate)
  const [hasMutatedDateRange, setHasMutatedDateRange] = useState(false)
  const daysBetweenDates = getDifferenceBetweenDates(
    selectedEndDate,
    selectedStartDate
  )

  React.useEffect(() => {
    if (
      defaultStartDate !== selectedStartDate ||
      defaultEndDate !== selectedEndDate
    ) {
      setHasMutatedDateRange(true)
    }
  }, [selectedStartDate, selectedEndDate, defaultStartDate, defaultEndDate])

  return {
    selectedStartDate,
    setSelectedStartDate,
    selectedEndDate,
    setSelectedEndDate,
    daysBetweenDates,
    hasMutatedDateRange,
  }
}
